import type { NumberReadings } from "./numbers.js";

/**
 * What each way of saying a number is called, and when it is the right one.
 *
 * The copy rather than the behaviour, kept apart for the same reason
 * `controls.ts` is kept apart from `options.ts`: this changes when the
 * explanation could be clearer, and that is not a change to how anything
 * works.
 */
/** The rows, in the order they are shown, and what each is called. */
export const numberRows: readonly {
  readonly key: keyof NumberReadings;
  readonly label: string;
  readonly note: string;
}[] = [
  {
    key: "cardinal",
    label: "As a quantity",
    note: "Counting things: 2026 个, 2026 块钱.",
  },
  {
    key: "digits",
    label: "Digit by digit",
    note: "Years, and any number read out rather than counted: 2026 年.",
  },
  {
    key: "yao",
    label: "Digit by digit, with yāo",
    note: "Phone and room numbers, where 一 is said yāo so it is not heard as 七.",
  },
  {
    key: "percent",
    label: "As a percentage",
    note: "百分之 comes first: literally “of a hundred parts, this many”.",
  },
];
